@if (isInAppBrowser()) {
	<button
		(click)="onPrivacyPolicy('/terms')"
		type="button"
		class="underline blue-link"
		data-testid="terms-btn"
	>
		Terms
	</button>
	and
	<button
		(click)="onPrivacyPolicy('/privacy')"
		type="button"
		class="underline blue-link"
		data-testid="privacy-policy-btn"
	>
		Privacy Policy
	</button>
} @else {
	<a
		routerLink="/terms"
		target="_blank"
		class="underline blue-link"
		data-testid="terms-link"
		>Terms</a
	>
	and
	<a
		routerLink="/privacy"
		target="_blank"
		class="underline blue-link"
		data-testid="privacy-policy-link"
		>Privacy Policy</a
	>
}
